import LandingLayout from '../../components/layout/LandingLayout';

export default function TermsOfService() {
  return (
    <LandingLayout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="text-3xl font-extrabold text-neutral-900 mb-2">Terms of Service</h1>
        <p className="text-sm text-neutral-500 mb-10">Last updated: April 24, 2026</p>

        <div className="prose prose-neutral max-w-none space-y-8 text-neutral-700 leading-relaxed">

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">1. Acceptance</h2>
            <p>
              By creating an account or using the Sage platform (&quot;Service&quot;), you agree to these Terms of
              Service (&quot;Terms&quot;). If you are using Sage on behalf of a practice or organization, you
              represent that you have authority to bind that entity to these Terms. If you do not agree,
              do not use the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">2. The Service</h2>
            <p>
              Sage Mental Inc. provides practice management software for mental health providers,
              including scheduling, clinical documentation, billing, and client communication tools.
              The Service is not a medical device and does not provide clinical advice.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">3. Accounts</h2>
            <p className="mb-3">
              You must provide accurate information when creating an account. You are responsible for
              maintaining the confidentiality of your credentials and for all activity under your account.
              Notify us immediately at{' '}
              <a href="mailto:security@sagemental.net" className="text-primary-600 hover:underline">security@sagemental.net</a>{' '}
              if you suspect unauthorized access.
            </p>
            <p>
              You may not share accounts, create accounts for others without their consent, or use the
              Service to impersonate any person or entity.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">4. HIPAA obligations</h2>
            <p>
              If you are a HIPAA covered entity or business associate, use of the Service is contingent
              on executing a Business Associate Agreement (BAA) with Sage Mental Inc. The BAA is
              incorporated into these Terms by reference. You are solely responsible for ensuring your
              use of Sage complies with applicable HIPAA regulations and your own compliance obligations.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">5. Acceptable use</h2>
            <p className="mb-3">You agree not to:</p>
            <ul className="list-disc pl-5 space-y-2">
              <li>Use the Service for any unlawful purpose or in violation of applicable law</li>
              <li>Upload or transmit malicious code, spam, or unsolicited communications</li>
              <li>Attempt to gain unauthorized access to any part of the Service or its infrastructure</li>
              <li>Reverse engineer, decompile, or attempt to derive the source code of the Service</li>
              <li>Use the Service to store PHI for individuals who are not your patients or clients</li>
              <li>Resell or sublicense access to the Service without written permission</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">6. Fees and billing</h2>
            <p>
              Subscription fees are described on the pricing page and may be updated with 30 days&apos;
              notice. All fees are in USD. Subscriptions renew automatically unless cancelled before the
              renewal date. Refunds are not provided for partial months. We reserve the right to suspend
              access for overdue accounts.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">7. Intellectual property</h2>
            <p>
              The Service, including its software, design, and documentation, is owned by Sage Mental Inc.
              and protected by intellectual property laws. You retain ownership of all data you input
              into the Service. You grant us a limited license to process that data solely to provide
              the Service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">8. Data portability and deletion</h2>
            <p>
              Upon request or account termination, we will provide an export of your practice data
              in a standard format within 30 days. After 60 days following termination, we may
              permanently delete your data. PHI deletion timelines are governed by your BAA.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">9. Disclaimer of warranties</h2>
            <p>
              The Service is provided &quot;as is&quot; without warranties of any kind, express or implied,
              including merchantability, fitness for a particular purpose, or uninterrupted availability.
              We do not warrant that the Service is error-free or that any particular uptime level will
              be maintained.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">10. Limitation of liability</h2>
            <p>
              To the maximum extent permitted by law, Sage Mental Inc. shall not be liable for indirect,
              incidental, special, or consequential damages arising from your use of the Service. Our
              total liability for any claim shall not exceed the fees paid by you in the three months
              preceding the claim.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">11. Termination</h2>
            <p>
              You may cancel your account at any time from the Settings page. We may suspend or
              terminate your account for violation of these Terms, non-payment, or if required by law,
              with reasonable notice where practicable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">12. Governing law</h2>
            <p>
              These Terms are governed by the laws of the State of Washington, without regard to
              conflict of law principles. Any disputes shall be resolved in the courts of King County,
              Washington.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-neutral-900 mb-3">13. Contact</h2>
            <p>
              Sage Mental Inc.<br />
              <a href="mailto:legal@sagemental.net" className="text-primary-600 hover:underline">legal@sagemental.net</a>
            </p>
          </section>

        </div>
      </div>
    </LandingLayout>
  );
}
